import { ComponentPropsWithoutRef, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface ISelectableOptionCardV2Props
  extends Omit<ComponentPropsWithoutRef<"input">, "onSelect" | "type"> {
  icon: ReactNode;
  title: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
  name?: string;
  className?: string;
}

export const SelectableOptionCardV2 = ({
  icon,
  title,
  description,
  selected,
  onSelect,
  name = "servico",
  className,
  ...rest
}: ISelectableOptionCardV2Props) => {
  return (
    <label
      className={twMerge(
        "relative flex w-full cursor-pointer items-center gap-6 overflow-hidden rounded-[10px] border border-solid border-transparent bg-[#e7edec] p-4 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)] has-[:checked]:border-[#ADB2B1] has-[:checked]:bg-[#D0D5D4]",
        className,
      )}
    >
      <input
        {...rest}
        type="radio"
        name={name}
        checked={selected}
        onChange={onSelect}
        className="absolute opacity-0"
      />

      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-black/10">
        {icon}
      </div>

      <div className="flex flex-1 flex-col gap-2">
        <p className="font-['Mulish'] text-xl font-extrabold tracking-[0.6px] text-[#2d2d2d]">
          {title}
        </p>
        <p className="font-['Mulish'] text-xs font-normal leading-4 text-[#2d2d2d]">
          {description}
        </p>
      </div>

      <img
        src="/assets/svgs/icon-center-focus.svg"
        alt=""
        className="absolute right-4 top-1/2 h-10 w-10 shrink-0 -translate-y-1/2"
      />
    </label>
  );
};
